import { ICON_COLOR, ICON_HEIGHT_8, IconWithTooltip } from '../../../Icon'
import Text from '../../../Text'

import { QA_NAME_CALENDAR_RAIL_BLOCK_WARNING } from './CalendarRailBlock.constants'

import * as styles from './CalendarRailBlock.module.css'

import DotIcon from '../../../../icons/dot.svg'

function CalendarRailBlock({ children, title, warning }) {
  return (
    <div className={styles.CalendarRailBlock}>
      <div className={styles.header}>
        <Text isSecondary>{title}</Text>
        {warning ? (
          <IconWithTooltip
            Icon={DotIcon}
            color={ICON_COLOR.Orange}
            qaName={QA_NAME_CALENDAR_RAIL_BLOCK_WARNING}
            size={ICON_HEIGHT_8}
            tooltip={warning}
          />
        ) : null}
      </div>
      {children}
    </div>
  )
}

export default CalendarRailBlock
